import React from 'react'
import Papa from 'papaparse'
import { nanoid } from 'nanoid'
import { Button, Col, Modal, Row, Upload, message } from 'antd'
import { UploadOutlined } from '@ant-design/icons'

const ImportModel = (props) => {
  const handleCancel = () => {
    props.setImportVisible(false)
  }

  let fileReader

  const handleImportFile = (content) => {
    // validate file
    const json = Papa.parse(content, {
      header: true
    })

    if (json.errors.length === 0) {
      const participants = json.data.map(d => {
        return Object.assign({}, d, { uuid: nanoid(), presence: false })
      })
      message.success('Import File Processed.')
      props.onImport(participants)
      props.setImportVisible(false)
    } else {
      message.error('Import file failed, please double check csv.')
    }
  }

  const downloadSample = () => {
    const dataToExport = `fid,last_name,first_name,demographic,age,club,rating
    email1@sample.com,last0,first0,open,30,Club A,B
    email2@sample.com,last1,first1,ladies,20,Club B,C
    email3@sample.com,last2,first2,cadet,13,Club C,U`

    const file = new window.Blob([dataToExport], { type: 'application/json' })

    const element = document.createElement('a')
    element.href = URL.createObjectURL(file)
    element.download = 'sample_fencer_import.csv'
    document.body.appendChild(element) // Required for this to work in FireFox
    element.click()
  }

  const properties = {
    name: 'file',
    beforeUpload (file, fileList) {
      fileReader = new window.FileReader()
      fileReader.onloadend = (e) => {
        const content = fileReader.result
        handleImportFile(content)
      }
      fileReader.readAsText(file)

      return false
    }
  }

  return (
    <Modal title='Import Fencers' visible={props.isImportVisible} onCancel={handleCancel} maskClosable={false} destroyOnClose footer={null}>
      <Row>
        <Col span={12} style={{ textAlign: 'left' }}>
          <Upload {...properties}>
            <Button icon={<UploadOutlined />}>Select Import File</Button>
          </Upload>
        </Col>
        <Col span={12} style={{ textAlign: 'right' }}>
          <Button onClick={downloadSample}>Download Sample</Button>
        </Col>
      </Row>
    </Modal>
  )
}

export default ImportModel
